import { useState, type ReactNode } from 'react';

/**
 * Tikla-ac kabuk (spec §3): KAPALI baslar ve kapaliyken cocugu MOUNT ETMEZ — cocugun sorgusu acilana
 * kadar hic calismaz (ilk acilis 7 istek butcesi, §4.4). Telefonda da kapali baslar.
 *
 * G2b: cerceve sayfadaki TEK listede (`tikla-ac-bloklar`, divide-y); kabuk kendi kenarligini cizmez.
 * C4'un dort cocugu (Isi/Sepet/Stok/KarKoprusu blok) kendi `SectionCard`'ini ciziyor ama ARTIK kendi
 * `title` PROP'unu GECMIYOR (bkz. IsiHaritasiBlok/SepetBlok/StokSatisBlok/KarKoprusuBlok) — kabugun
 * `baslik`i zaten ayni bilgiyi bir kez basiyor; ikinci bir baslik metni URETILMEZ (DOM'da hic yer almaz,
 * CSS ile gizlenmez). Govde `[&_section]:border-0 [&_section]:rounded-none [&_section]:shadow-none` ile
 * cocugun SectionCard cercevesini (kenarlik/yuvarlatma/golge) bastirir — kalan tek gorsel cerceve
 * kabugun disindaki sayfa listesidir. `border-t` govde ile dugme arasina TEK ayrac cizgisi ekler
 * (cocugun kendi cercevesi yoksa gorsel kopukluk olmasin diye); `p-3` YOK — ic icerik kendi `SectionCard`
 * govde dolgusunu (`p-5`, header `px-5 py-3.5`) zaten tasiyor, ikinci bir dolgu eklemek fazladan bosluk
 * birakirdi. `subtitle`/notlar (KapsamNotu vb.) SectionCard'ta KALIR — `SectionCard` artik `subtitle` tek
 * basina (title olmadan) da basiyor (primitives.tsx).
 *
 * `bilgi` (Controller ruling S3, spec §7.3): TiklaAc alt basligindan dusen kapsam notu ("kanal süzgeci
 * uygulanmaz" vb.) SESSIZCE atilmaz; basligin yanina bir `Bilgi` ⓘ olarak eklenir. Ayri bir `<button>`
 * olarak (toggle dugmesinin ICINE degil) durur — bir `<button>` icine ikinci bir `<button>` gecersiz HTML
 * olur ve ⓘ'ye tiklamak yanlislikla satiri acar/kapatirdi.
 */
export function TiklaAc({
  anahtar,
  baslik,
  altBaslik,
  bilgi,
  children,
}: {
  anahtar: string;
  baslik: string;
  altBaslik?: string;
  bilgi?: ReactNode;
  children: ReactNode;
}) {
  const [acik, setAcik] = useState(false);
  return (
    <section data-testid={`tikla-ac-${anahtar}`} className="min-w-0">
      <div className="w-full flex items-center gap-3 px-5 py-3.5">
        <button
          type="button"
          data-testid={`tikla-ac-${anahtar}-dugme`}
          aria-expanded={acik}
          onClick={() => setAcik((a) => !a)}
          className="focus-ring flex-1 min-w-0 flex items-center justify-between gap-3 text-left"
        >
          <span className="min-w-0">
            <span className="block text-[14px] font-semibold text-ink-900 leading-tight">{baslik}</span>
            {altBaslik && <span className="block text-[12px] text-ink-500 mt-0.5">{altBaslik}</span>}
          </span>
          <span aria-hidden="true" className="text-ink-500 shrink-0">{acik ? '▲' : '▼'}</span>
        </button>
        {bilgi}
      </div>
      {acik && (
        <div
          data-testid={`tikla-ac-${anahtar}-govde`}
          className="border-t border-border [&_section]:border-0 [&_section]:rounded-none [&_section]:shadow-none"
        >
          {children}
        </div>
      )}
    </section>
  );
}
